import { Pipe, PipeTransform } from '@angular/core';
import {
  CAMPAIGNS_MANAGEMENT_ISSUES_STATUS_LOOKUP,
  CampaignsManagementIssuesStatus,
} from 'ag-common-lib/lib/lists/campaign-management-issues-status.enum';

@Pipe({ name: 'campaignsIssueStatus' })
export class CampaignsTaskIssuesStatusPipe implements PipeTransform {
  transform(status: CampaignsManagementIssuesStatus, type: 'class' | 'text' = 'text'): string {
    if (!status) {
      return '';
    }
    const lookupByStatus = CAMPAIGNS_MANAGEMENT_ISSUES_STATUS_LOOKUP.find(lookup => lookup?.value === status);
    return type === 'class' ? lookupByStatus?.cssClass : lookupByStatus?.description;
  }
}
